import React__default, { useState, useEffect } from 'react';
import { SizeContext } from '../../contexts/SizeContext.es.js';
import { CommonStyles } from '../BaseProps/index.es.js';
import styled from '@emotion/styled';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getColor = (props, type) => {
  var _a, _b, _c, _d, _e, _f, _g;
  switch (type) {
    case "bg": {
      if (props.disabled) {
        if (props.checked)
          return (_a = props.theme) == null ? void 0 : _a.colors.primary100;
        return (_b = props.theme) == null ? void 0 : _b.colors.background;
      } else {
        if (props.checked)
          return (_c = props.theme) == null ? void 0 : _c.colors.primary500;
        return (_d = props.theme) == null ? void 0 : _d.colors.divider;
      }
    }
    case "knob":
    default: {
      if (!props.disabled)
        return (_e = props.theme) == null ? void 0 : _e.colors.white;
      return props.checked ? (_f = props.theme) == null ? void 0 : _f.colors.white : (_g = props.theme) == null ? void 0 : _g.colors.divider;
    }
  }
};
const getSize = (size) => {
  switch (size) {
    case "s":
      return [36, 22, 14];
    default:
      return [48, 28, 20];
  }
};
const Switch = (_a) => {
  var _b = _a, {
    checked,
    defaultChecked,
    disabled,
    onChange,
    size: customizeSize
  } = _b, rest = __objRest(_b, [
    "checked",
    "defaultChecked",
    "disabled",
    "onChange",
    "size"
  ]);
  const size = React__default.useContext(SizeContext);
  const mergeSize = customizeSize || size || "m";
  const [width, height, roundWidth] = getSize(mergeSize);
  const [initCheck, setInitCheck] = useState();
  useEffect(() => {
    setInitCheck(checked === void 0 ? defaultChecked : checked);
  }, []);
  return /* @__PURE__ */ React__default.createElement(StyledSwitch, __spreadValues({
    style: { width, height }
  }, rest), /* @__PURE__ */ React__default.createElement(StyledInput, {
    type: "checkbox",
    checked: checked === void 0 ? initCheck : checked,
    disabled,
    onChange: (e) => !disabled && onChange && onChange(e.target.checked)
  }), /* @__PURE__ */ React__default.createElement(SwitchInner, {
    roundWidth,
    switchWidth: width,
    checked: checked === void 0 ? initCheck : checked,
    disabled
  }));
};
const StyledSwitch = styled.div`
  ${CommonStyles}
  display: inline-block;
  position: relative;
`;
const SwitchInner = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  transition: background-color 0.3s;
  background-color: ${(p) => getColor(p, "bg")};
  &:before {
    content: '';
    position: absolute;
    height: ${(p) => p.roundWidth}px;
    width: ${(p) => p.roundWidth}px;
    background: ${(p) => getColor(p, "knob")};
    transition: left 0.35s;
    border-radius: 50%;
    top: 4px;
    left: ${(p) => p.checked ? `${p.switchWidth - p.roundWidth - 4}px` : "4px"};
    box-shadow: ${(p) => p.disabled ? "none" : p.theme.shadow(p, "down-s", "black")};
  }
`;
const StyledInput = styled.input`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  cursor: ${(p) => p.disabled ? "not-allowed" : "pointer"};
  opacity: 0;
`;

export { Switch };
